var map = {
	"./KPMG-Logo.jpg": 162,
	"./Oracle_Logo_1.png": 163,
	"./Pluralsight_logo.jpg": 164,
	"./Udemy_logo.png": 165,
	"./address_image.svg": 166,
	"./animated_kritagya.png": 167,
	"./animated_logo.svg": 168,
	"./blogs_image.svg": 169,
	"./bvicam_logo.png": 170,
	"./cloud_infrastructure.svg": 171,
	"./codeInLogo.png": 172,
	"./coding-blocks_logo.png": 173,
	"./contactMail.png": 174,
	"./coursera_logo.png": 175,
	"./cube_highways_logo.jpg": 176,
	"./data_science.svg": 177,
	"./deeplearning_ai_logo.png": 178,
	"./delhivery_logo.png": 179,
	"./developerActivity.svg": 180,
	"./dsc_logo.png": 181,
	"./education.svg": 182,
	"./experience.svg": 183,
	"./feelingProud.svg": 184,
	"./freecopy_logo.png": 185,
	"./fullstack.svg": 186,
	"./gcp_logo.png": 187,
	"./github_logo.png": 188,
	"./gndu_logo.png": 189,
	"./googleAssistant.jpg": 190,
	"./googleAssistant.svg": 191,
	"./google_logo.png": 192,
	"./ibm_logo.png": 193,
	"./intel_logo.jpg": 194,
	"./jsFramework.svg": 195,
	"./legato_logo.png": 196,
	"./manOnTable.svg": 197,
	"./microsoft_logo.png": 198,
	"./mozilla_logo.png": 199,
	"./muffito_logo.png": 200,
	"./nextuLogo.jpg": 201,
	"./niit_logo.png": 202,
	"./nptel_logo.png": 203,
	"./oracle_logo.png": 204,
	"./portfolio.gif": 205,
	"./programmer.svg": 206,
	"./projects_image.svg": 207,
	"./pwa.png": 208,
	"./saayaHealthLogo.png": 209,
	"./stanford_logo.png": 210,
	"./talksCardBack.svg": 211,
	"./talksCardBackAlt.svg": 212,
	"./ui_ux_design.svg": 213,
	"./vmm-education_logo.jpg": 214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;